import { render, staticRenderFns } from "./UploadQuestion.vue?vue&type=template&id=7539c6e2&"
import script from "./UploadQuestion.vue?vue&type=script&lang=js&"
export * from "./UploadQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports